<template>
<pt-report-data></pt-report-data>
</template>
<script>
import ptReportData from "cps/pt-report/withData";
export default {
  components: {
    ptReportData,
  },
}
</script>